import { ConnectorStages } from '../../constants';
import { ConnectorDetailsTabValues } from '../../pages/connector-details/main';

const convertQueryParamStageToMappedValues = (
  stage?: string
): ConnectorStages => {
  switch (stage) {
    case 'dev': {
      return ConnectorStages.DEV;
    }
    case 'publish': {
      return ConnectorStages.PUBLISH;
    }
    case 'qc': {
      return ConnectorStages.QC;
    }
    default: {
      return ConnectorStages.PUBLISH;
    }
  }
};

export const getConfigsParamFromUrl = () => {
  const search = window.location.search.replace('?', '');

  if (!search) {
    return { stage: ConnectorStages.PUBLISH };
  }

  const decoded = atob(decodeURIComponent(search));
  const searchParams = JSON.parse(decoded);

  return {
    tab:
      searchParams?.['connector-details-tab-param'] ||
      ConnectorDetailsTabValues.OVERVIEW,
    stage: convertQueryParamStageToMappedValues(searchParams?.stage),
  };
};
